module.exports = __webpack_public_path__ + "static/media/chart-icon.b41256ed.svg";